module.exports = __webpack_public_path__ + "img/baner_new_02_06_2023.0f77a6f9.jpg";